import React from 'react';
import { Provider } from 'react-redux';
import { store } from './context/store';
import Routes from './Routes';
import './css/App.css';

const App: React.FunctionComponent = () => {
    return (
        <Provider store={store}>
            <Routes />
        </Provider>
    );
};

export default App;
